import { InputSwitch } from 'primereact/inputswitch';

export interface BaseSwitchProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  /** Accessible name; the visible label sits beside the switch in the row. */
  'aria-label': string;
  disabled?: boolean;
}

/** An on/off switch for settings rows (applies at once, no Save button). */
export function BaseSwitch({ id, checked, onChange, 'aria-label': ariaLabel, disabled }: BaseSwitchProps) {
  return (
    <InputSwitch
      inputId={id}
      checked={checked}
      disabled={disabled}
      onChange={(e) => {
        onChange(e.value);
      }}
      aria-label={ariaLabel}
      className="cd-switch"
      // The inner input is the real switch (role="switch"); PrimeReact also marks the wrapper as
      // a checkbox, which nests one control in another for screen readers (axe nested-interactive).
      pt={{ root: { role: 'none', 'aria-checked': undefined } }}
    />
  );
}
